import type { QueryClient } from '@tanstack/react-query';

export const localizedReferenceDataKeys = {
  countries: ['countries'] as const,
  companyLevels: ['companies', 'companyLevels'] as const,
  parentAssignableLevels: ['company', 'parentAssignableLevels'] as const,
  userRoles: ['roles'] as const,
  globalUserRoles: ['globalRoles'] as const,
};

// Clears localized lookup values and refetches any active consumers.
export async function resetLocalizedReferenceData(
  queryClient: QueryClient
): Promise<void> {
  await Promise.all(
    Object.values(localizedReferenceDataKeys).map((queryKey) =>
      queryClient.resetQueries({ queryKey })
    )
  );
}
